import React, { useEffect, useState } from "react";
import { Button } from "../../../design/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../../../design/dialog";
import { ErrorMessage } from "../../../design/fieldset";
import { useSpousalSupportPayment } from "../../../contexts/SpousalSupportPaymentContext";
import { SpousalSupportPayment } from "../../../models/SpousalSupportPayment";

interface Props {
  spousalSupportPayment: SpousalSupportPayment;
}

interface Errors {
  title?: string;
  description?: string;
}

const EditSpousalSupportPaymentButton: React.FC<Props> = ({
  spousalSupportPayment,
}) => {
  const { updateSpousalSupportPayment } = useSpousalSupportPayment();
  const [isOpen, setIsOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {}, [spousalSupportPayment]);

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }
    setIsSaving(true);
    setError(null);

    try {
      await updateSpousalSupportPayment(spousalSupportPayment._id, {});
      clearForm();
    } catch (e) {
      console.error(e);
      setError("Failed to update spousalSupportPayment. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  const clearForm = () => {
    setIsOpen(false);
    setError(null);
  };

  return (
    <>
      <Button type="button" onClick={() => setIsOpen(true)}>
        Edit
      </Button>
      <Dialog open={isOpen} onClose={setIsOpen}>
        <DialogTitle>Edit SpousalSupportPayment</DialogTitle>
        <DialogBody>{error && <ErrorMessage>{error}</ErrorMessage>}</DialogBody>
        <DialogActions>
          <Button plain onClick={clearForm}>
            Cancel
          </Button>
          <Button disabled={isSaving} onClick={handleSubmit}>
            {isSaving ? "Saving..." : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditSpousalSupportPaymentButton;
